<template lang="pug">
	.device-types-filter
		div(v-if="deviceTypes")
			ul
				li.heading.center(id="deviceTypeHeading") DEVICE SELECTION
					information-tooltip.tooltip(
											text=`Total stations can be filtered by device types. The filtered list will    include only Total Stations based on:
												Optional: The filtered list will include Total Stations whether they include a device of this type or not.
												Required: Total Station must have at least 1 device of this type before to be displayed.
												Exclude: Total Stations with these devices will not be displayed.

												Example: Checking RSU = Optional, TSC = Required, and ESS = Excluded will create a list of Total Stations that must have a TSC, may or may not have an RSU, and do not have ESSs.`
										)
						i.fas.fa-question-circle

				table
					tr.trheader
						th
							|
						th
							| DEVICE TYPES
						th
							| OPTIONAL
						th
							| REQUIRED
						th
							| EXCLUDE
					tr(v-for="dt in sortedDeviceTypes" :key="dt.id" )
						td
							img(:src="deviceTypeImageUrlByID(dt.id)")
						td.deviceTypeName
							span(:title="`#${dt.id}: ${dt.shortName}`")
								label {{ dt.fullName }} ({{dt.shortName}}) {{deviceTypeRadio[dt.shortName]}}
						td.radiodiv
							input(type="radio" :id="dt.id + dt.shortName" v-model="dt.filterDeviceType" value="Optional" @click="setShowDeviceType({ deviceTypeId: dt.id, filter:'Optional'})")
						td.radiodiv
							input(type="radio" :id="dt.id + dt.shortName" v-model="dt.filterDeviceType" value="Required"
							@click="setShowDeviceType({ deviceTypeId: dt.id, filter:'Required'})")
						td.radiodiv
							input(type="radio" :id="dt.id + dt.shortName" v-model="dt.filterDeviceType" value="Exclude"
							@click="setShowDeviceType({ deviceTypeId: dt.id, filter:'Exclude'})")

				.flex.space-between.align-center
					label Show Empty Total Stations
					toggle-switch(size="sm" v-model="isEmptyTSVisible" @input="ShowEmptyTS(isEmptyTSVisible)")

				li.heading.center DEVICE STATUS
					information-tooltip.tooltip( text=`If one or more device types are specified as Required, then the Total Stations  displayed will be filtered by the device status selected. Example: RSU is “Required” and status is marked “deployed,” then all Total Stations with deployed RSU will be displayed. If no device types are required, then the status of all device types will be compared against the selected status values.` )
						i.fas.fa-question-circle

				.statusDiv
					.tdwidth(v-for="(option, key) in deviceStatusLib")
						input.chkbox(type="checkbox" :id="key" :disabled="isNoDeviceSelected" :value="option.selected" v-model="option.selected" @change="toggleDeviceStatus")
						select.formattedText(:style="'appearance:none;width:15px;height:15px;margin:5px;background-color:'+ option.color")
						span
							label {{option.formattedText}}

				br
				li.heading INFRASTRUCTURE OWNER
					information-tooltip( text=`All filters work in conjunction with each other. Specifying an Infrastructure Owner will filter the list of Total Stations having devices with the selected owner.` )
							i.fas.fa-question-circle

					select.input(	id="clientowner" :style="'width:135px; margin-left:15px;'"
								name="clientowner"
								v-model.number="infrastructureOwnerId"
								)
						option(value="0" :disabled="isNoDeviceSelected") All Owners
						option(v-for="option in clients" :value="option.clientid") {{ option.clientname }}
				br
				li.heading INFRASTRUCTURE OPERATOR
					information-tooltip( text=`All filters work in conjunction with each other. Specifying an Infrastructure Operator will filter the list of Total Stations having devices with the selected operator.` )
							i.fas.fa-question-circle
					select.input(	id="clientoperator" :style="'width:135px; '"
							name="clientoperator"
							v-model.number="infrastructureOperatorId"
							:options="clients")
						option(value="0" :disabled="isNoDeviceSelected") All Operators
						option(v-for="option in clients" :value="option.clientid") {{ option.clientname }}

				br
				li.heading PROJECT NUMBER
					information-tooltip( text=`List of Total Stations which includes devices with the added project number.` )
							i.fas.fa-question-circle
					input.input(type="text" v-model="projectId" @change="setProjectId" :style="'width:135px; margin-left:70px'")

</template>
<script>
import _ from "lodash";
import InputSelect from "@/components/InputSelect";
import { Vue, Component, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import DeviceManagerStoreModule from "@/store/modules/device-manager";
import DeviceStatusLib from "@/common/device-statuslib.js";
import TotalStationStoreModule from "@/store/modules/total_station";
import InformationTooltip from "@/components/InformationTooltip";
import ToggleSwitch from "@/components/ToggleSwitch";

const dmStoreMod = namespace(DeviceManagerStoreModule.MODULE_NAME);
const tsStoreMod = namespace(TotalStationStoreModule.MODULE_NAME);

@Component({
	components: {
		InformationTooltip,
		InputSelect,
		ToggleSwitch
	}
})
class DeviceTypeFilter extends Vue {
	deviceStatusLib = {};
	isNoDeviceSelected = false;
	statusProposed = false;
	statusInMaintenance = false;
	statusTFMApproval = false;
	statusDeployed = false;
	isEmptyTSVisible = true;
	deviceTypeRadio = [];
	projectId = "";

	@dmStoreMod.Getter("deviceTypeIconURLByTypeID") deviceTypeImageUrlByID;
	@dmStoreMod.Getter("deviceTypes") deviceTypes;
	@dmStoreMod.Getter("doesDeviceTypeHaveModule") doesDeviceTypeHaveModule;
	// @dmStoreMod.Getter("shouldShowDeviceType") shouldShowDeviceType;

	@dmStoreMod.Mutation(
		DeviceManagerStoreModule.MUTATION_TYPES.SET_SHOW_DEVICE_TYPE
	)
	setShowDeviceType;

	@tsStoreMod.Mutation("SET_SELECTED_DEVICE_TYPE_IDS") setSelectedDeviceTypeIds;
	@tsStoreMod.Mutation("SET_SELECTED_DEVICE_OWNER_ID") setSelectedOwnerId;
	@tsStoreMod.Mutation("SET_SELECTED_DEVICE_OPERATOR_ID") setSelectedOperatorId;
	@tsStoreMod.Mutation("SET_SELECTED_DEVICE_PROJECT_ID") setSelectedProjectId;
	@tsStoreMod.Mutation("SET_EXCLUDED_DEVICE_TYPE_IDS")
	setUnSelectedDeviceTypeIds;
	@tsStoreMod.Getter("selectedDeviceStatusIds") selectedDeviceStatusIds;
	@tsStoreMod.Getter("userClientAccess") UserClientAccess;
	@tsStoreMod.Getter("selectedDeviceOwnerId") selectedOwner;
	@tsStoreMod.Getter("selectedDeviceOperatorId") selectedOperator;
	@tsStoreMod.Mutation("SET_SELECTED_DEVICE_STATUS_IDS")
	setSelectedDeviceStatusIds;

	get clients() {
		return this.UserClientAccess ? this.UserClientAccess : [];
		// return this.$store.state.user.userClientAccess;
	}
	get infrastructureOwnerId() {
		if (this.selectedOwner.length == 0) return 0;
		else return this.selectedOwner;
	}
	set infrastructureOwnerId(val) {
		this.setSelectedOwnerId(val);
	}
	get infrastructureOperatorId() {
		if (this.selectedOperator.length == 0) return 0;
		return this.selectedOperator;
	}
	set infrastructureOperatorId(val) {
		this.setSelectedOperatorId(val);
	}

	/**
	 * Returns currently active device statuses.
	 */
	get activeDeviceStatusIds() {
		const values = _.filter(this.deviceStatusLib, n => {
			return n.selected == true;
		}).map(deviceStatus => deviceStatus.Id);
		return values;
	}

	ShowEmptyTS(isTrue) {
		if (isTrue) {
			this.$emit("ShowEmptyTS", true);
		} else {
			this.$emit("ShowEmptyTS", false);
		}
	}

	setProjectId(event) {
		this.setSelectedProjectId(event.target.value);
	}

	/**
	 * Returns sorted device type list.
	 */
	get sortedDeviceTypes() {
		if (!this.deviceTypes) return [];
		return Object.values(this.deviceTypes).sort((a, b) => {
			const am = this.doesDeviceTypeHaveModule(a.id) && !a.disabled;
			const bm = this.doesDeviceTypeHaveModule(b.id) && !b.disabled;
			if (am && !bm) return -1;
			if (bm && !am) return 1;
			const al = a.loading == false && a.entries && a.entries.length > 0;
			const bl = b.loading == false && b.entries && b.entries.length > 0;
			if (al && !bl) return -1;
			if (bl && !al) return 1;
		});
	}

	/**
	 * Create lifecycle hook
	 */
	created() {
		this.deviceTypeRadio[1] = "Optional";
		this.deviceTypeRadio[2] = "Optional";
		this.deviceTypeRadio[3] = "Optional";
		this.initializeDeviceStatusLib(DeviceStatusLib);
		this.setSelectedDeviceStatusIds(this.activeDeviceStatusIds);
	}

	/**
	 * Clone Device Status Library to local variable.
	 * Modifies library object to include "selected" property
	 * on each status, used to determine active values.
	 */
	initializeDeviceStatusLib(deviceStatusLib) {
		let libClone = _.clone(deviceStatusLib);
		// Remove "Removed" status from list as not applicable here.
		delete libClone["Removed"];
		_.forEach(libClone, deviceStatus => {
			deviceStatus.selected = true;
		});
		this.deviceStatusLib = libClone;
	}

	/**
	 * Toggles selected property of Device Status for provided key.
	 */
	toggleDeviceStatus() {
		this.setSelectedDeviceStatusIds(this.activeDeviceStatusIds);
	}

	/**
	 * Watcher on deviceTypes in Device Manager module.
	 * Pushes active device type IDs into Total Station module.
	 */
	@Watch("deviceTypes", { deep: true })
	onDeviceTypesChange(value) {
		const optionalDeviceTypeIds = _.filter(value, deviceType => {
			return deviceType.filterDeviceType === "Optional";
		}).map(deviceType => deviceType.deviceTypeId);

		const requiredDeviceTypeIds = _.filter(value, deviceType => {
			return deviceType.filterDeviceType === "Required";
		}).map(deviceType => deviceType.deviceTypeId);

		const excludedDeviceTypeIds = _.filter(value, deviceType => {
			return deviceType.filterDeviceType === "Exclude";
		}).map(deviceType => deviceType.deviceTypeId);

		if (optionalDeviceTypeIds.length == 0 && requiredDeviceTypeIds == 0) {
			this.isNoDeviceSelected = true;
		} else this.isNoDeviceSelected = false;

		this.setSelectedDeviceTypeIds(requiredDeviceTypeIds);
		this.setUnSelectedDeviceTypeIds(excludedDeviceTypeIds);
	}

	/**
	 * Watcher on deviceStatus in Device Manager module.
	 * Pushes active device status IDs into Total Station module.
	 */
	@Watch("selectedDeviceStatusIds", { deep: true })
	onDeviceStatusChange(value) {
		let selectedId = -1;
		_.forEach(this.deviceStatusLib, function(o) {
			selectedId = _.findIndex(value, function(i) {
				return o.Id == i;
			});
			if (selectedId > -1) o.selected = true;
			else o.selected = false;
		});
	}
}
export default DeviceTypeFilter;
</script>
<style lang="stylus" scoped>
.statusDiv
	width 300px
	display inline
	.chkbox
		margin 5px
	.tdwidth
		display flex

		&:nth-of-type(n)
			float left
			width 160px

		&:nth-of-type(2n)
			width 180px
		.breakdiv
			height 10px
		i
			margin 5px
		.fa-check-square
			width 20px
			height 20px

table
	tr
		&.trheader
			padding 4px 0 4px 0
			font-weight 700
		th
			background-color #eee
			// text-align center
			font-size 12px
			color $brand-color
		&:nth-of-type(2n)
			td
				background none
		td
			span
				overflow hidden
				text-overflow ellipsis
				margin-right 0.25em
				flex 1
				label
					font-weight bold
					font-size 12px
			&.radiodiv
				text-align center
			&.deviceTypeName
				font-size smaller



			img
				display block
				padding 0.05em
				border-radius 0.25em
				border solid 0.1rem rgba(0, 0, 0, 0.8)
				width 1.25em
				height 1.25em
.tooltip
	margin 10px
	color red
	span
		&.tooltiptext
			bottom 0%
			left 0%
			margin-left 2px


.device-types-filter
	width 550px
	height 535px
	font-size 13px
	text-align left
	transition 0.5s
	background-color $very-light-bg-color
	padding 0.5em
	margin 4em 0.2em 0.5em 0.2em
	box-shadow 0 0.1em 0.1em rgba(0, 0, 0, 0.3)

	.device-status
		font-size 15px

		label
			font-size 9px
	ul
		list-style none
		margin-bottom 10px

	span
		overflow hidden
		text-overflow ellipsis
		margin-right 0.25em
		flex 1
		label
			font-weight bold

	li
		.row
			z-index 5
			user-select none
			border-radius 0.25em
			position relative
			display flex
			justify-content space-between
			align-items center
			cursor pointer
			padding 0.4em 0.5em
			transition background-color 0.2s ease
			position relative
			margin 0 -0.25em

			.formattedText
				margin 0.25em
			.type-icon
				margin-right 0.25em
				opacity 1

			.button
				margin-right 0.5em

			&:hover
				background #fff

		&.disabled
			opacity 0.33

			.row
				cursor not-allowed

				&:hover
					background inherit

.heading
	padding 3px 0 3px 0
	font-weight 700
	font-size 13px
	color $brand-color

.center
	text-align center
.flex
	display flex
	margin-top 0.5em
	margin-left 2.5em
	align center
	label
		padding-right 25px
</style>
